import {Modal, Button, Form} from '@goproblems/ui';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

export enum ExportType {
    All = 'all',
    CurrentPath = 'currentPath',
    CurrentPathWithDescendants = 'currentPathWithDescendants',
}

type ExportSgfModalProps = {
    show: boolean;
    onHide: () => void;
    onConfirm: (exportType: ExportType, includeCustomTags: boolean) => void;
};

export const ExportSgfModal = ({
    show,
    onHide,
    onConfirm,
}: ExportSgfModalProps) => {
    const {t} = useTranslation();
    const [exportType, setExportType] = useState<ExportType>(ExportType.All);
    const [includeCustomTags, setIncludeCustomTags] = useState(false);

    const handleConfirm = () => {
        onConfirm(exportType, includeCustomTags);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('export_sgf.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('export_sgf.type')}</Form.Label>
                        <Form.Check
                            type="radio"
                            id="export-all"
                            label={t('export_sgf.all')}
                            checked={exportType === ExportType.All}
                            onChange={() => setExportType(ExportType.All)}
                        />
                        <Form.Check
                            type="radio"
                            id="export-current-path"
                            label={t('export_sgf.current_path')}
                            checked={exportType === ExportType.CurrentPath}
                            onChange={() =>
                                setExportType(ExportType.CurrentPath)
                            }
                        />
                        <Form.Check
                            type="radio"
                            id="export-current-path-with-descendants"
                            label={t('export_sgf.current_path_descendants')}
                            checked={
                                exportType ===
                                ExportType.CurrentPathWithDescendants
                            }
                            onChange={() =>
                                setExportType(
                                    ExportType.CurrentPathWithDescendants
                                )
                            }
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Check
                            type="checkbox"
                            id="include-custom-tags"
                            label={t('export_sgf.include_custom_tags')}
                            checked={includeCustomTags}
                            onChange={e =>
                                setIncludeCustomTags(e.target.checked)
                            }
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('common.cancel')}
                </Button>
                <Button variant="primary" onClick={handleConfirm}>
                    {t('common.export')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
